// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/chat.test.tsx
/**
 * Shared chrome for in-stream status accordion headers and bodies.
 * why: a leaf module — AgentSteps and SubagentToolStep both need these tokens
 * and AgentSteps already imports SubagentToolStep, so putting the strings in
 * either file made a cycle (review #5399).
 */

const STATUS_PANEL_FOCUS_RING =
  "outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-puntt-accent-7";

const STATUS_PANEL_TOGGLE_BASE = `flex w-full items-center gap-2 px-2.5 py-1.5 text-left ${STATUS_PANEL_FOCUS_RING}`;

/** Sub-agent card header: status row on top, the name stacked underneath. */
export const STATUS_PANEL_CARD_MUTED_CLASS = `flex w-full flex-col items-stretch gap-1.5 px-3 py-2.5 text-left bg-transparent ${STATUS_PANEL_FOCUS_RING}`;

/** Done-check color for tool calls and review steps, matching the progress rail. */
export const STATUS_DONE_ICON_CLASS = "text-puntt-neutral-grayA-11";

/** Hover fill for muted accordion headers. Rest stays transparent. */
export const STATUS_PANEL_TOGGLE_HOVER_CLASS = "hover:bg-puntt-neutral-gray-3";

/** Muted panels (AgentSteps, SearchProgress): transparent header — no fill/stroke. */
export const STATUS_PANEL_TOGGLE_MUTED_CLASS = `${STATUS_PANEL_TOGGLE_BASE} bg-transparent`;

/** Review checklist: white shell with a white header row (frame 02). */
export const STATUS_PANEL_TOGGLE_LIGHT_CLASS = `${STATUS_PANEL_TOGGLE_BASE} bg-base-white hover:bg-base-white`;

/** @deprecated Use STATUS_PANEL_TOGGLE_MUTED_CLASS or STATUS_PANEL_TOGGLE_LIGHT_CLASS. */
export const STATUS_PANEL_TOGGLE_CLASS = STATUS_PANEL_TOGGLE_MUTED_CLASS;

// why: bare body matches EnterpriseImpact / FeedMemoryCard — no divider stroke or fill.
export const STATUS_PANEL_ITEMS_MUTED_CLASS = "bg-transparent px-1.5 py-1.5";

export const STATUS_PANEL_ITEMS_LIGHT_CLASS =
  "border-t border-puntt-neutral-gray-4 bg-base-white px-1.5 py-1.5";

/** @deprecated Use STATUS_PANEL_ITEMS_MUTED_CLASS or STATUS_PANEL_ITEMS_LIGHT_CLASS. */
export const STATUS_PANEL_ITEMS_CLASS = STATUS_PANEL_ITEMS_MUTED_CLASS;
